import { useEffect } from 'react';

/**
 * Sends the window to the top when the page mounts.
 *
 * React Router keeps the window offset across navigations, so a page opened
 * from halfway down a long one starts halfway down itself. Pages that are
 * always read from the beginning want this; list pages that restore where the
 * user left them do not.
 */
export const useScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
